export default "__VITE_ASSET__Czjj5348__"